import { Flex, Text } from "@chakra-ui/react";
import React from "react";
interface aboutSummaryProps {}
const AboutSummary: React.FC<aboutSummaryProps> = () => {
  return (
    <Flex
      h="30vh"
      w="100%"
      justify="center"
      align="center"
      direction="column"
      bg="#168aad"
      color="white"
    >
      <Text fontSize="2xl" align="center">
        We strive to promote transformation in the workplace.
        <br />
        We believe in the our beautiful country and work toward aligning
        ourselves and our stakeholders to the National Development Plan.
        <br />
        We are passionate about creating employment opportunities through
        various initiatives.
      </Text>
    </Flex>
  );
};

export default AboutSummary;
